import type { ContractChoice } from '@/types/contract';

export const GET_DUGOUT_CONTRACTS_QUERY_KEY = 'getDugoutContracts';

export const GET_DUGOUT_CONTRACT_INSURANCE_ENTITIES_QUERY_KEY =
  'getDugoutContractInsuranceEntities';

export const GET_DUGOUT_CONTRACT_VERSION_HISTORY_QUERY_KEY = 'getDugoutContractVersionHistory';

export const CONTRACTS_PATH = '/contracts';

// Mirrors ContractStatus in backend/homebase/contracts/models/contract_status.py.
export const CONTRACT_STATUSES: ContractChoice[] = [
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'active', label: 'Active' },
  { value: 'expired', label: 'Expired' }
];
